import type { MediaSticker } from './api';

/** The animation facts the server adds to an animated entry (frameCount > 1); static stickers have none. */
export type StickerAnimationFacts = Pick<MediaSticker, 'frameCount' | 'durationMs'>;

export function isAnimatedSticker(sticker: Pick<MediaSticker, 'frameCount'>): boolean {
  return (sticker.frameCount ?? 0) > 1;
}

/** One loop in seconds with one decimal: `2400 -> "2.4 s"`. */
export function loopSeconds(durationMs: number): string {
  return `${(durationMs / 1000).toFixed(1)} s`;
}

/** The badge text: "Animated · 2.4 s", or just "Animated" when the server sent no duration. */
export function animatedBadgeLabel(sticker: StickerAnimationFacts): string {
  return sticker.durationMs ? `Animated · ${loopSeconds(sticker.durationMs)}` : 'Animated';
}
